
import React, { useState } from "react";
import {
  checkRoloAccount,
  sendDeleteAccountOtp,
  deleteRoloAccount,
} from "./services/authService";
import "./DeleteAccount.css";
import logo from "./assets/ROLO LOGO TM-01 (2).png";

const DELETE_REASONS = [
  "No exciting offers",
  "Poor App experience",
  "Moved to different ride booking app",
  "Poor Customer Support",
  "I have a privacy concern with Rolo",
  "Some features are missing",
  "I don't use this service often enough",
  "Other reasons",
];

function DeleteAccount() {
  const [step, setStep] = useState(1);

  const [mobileNumber, setMobileNumber] = useState("");
  const [selectedReason, setSelectedReason] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const [otp, setOtp] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [hasActiveShield, setHasActiveShield] = useState(false);

  // =========================================================
  // STEP 1 - CHECK ACCOUNT
  // =========================================================

  const handleCheckAccount = async (e) => {
    e.preventDefault();

    setError("");

    if (mobileNumber.length !== 10) {
      setError("Please enter a valid 10-digit mobile number.");
      return;
    }

    setLoading(true);

    try {
      const response = await checkRoloAccount({
        mobile_no: mobileNumber,
      });

      console.log("Check Account:", response);

      if (response?.success === "1") {
        /*
          Update this field according to the exact backend response
          when the account has an active RoloShield.
        */

        const activeShield =
          response?.data?.active_roloshield === true ||
          response?.data?.has_active_shield === true ||
          response?.data?.active_shield === true ||
          response?.data?.roloshield_active === true;

        if (activeShield) {
          setHasActiveShield(true);
          return;
        }

        setStep(2);
      } else {
        setError(
          response?.message ||
            "We could not find a Rolo account associated with these details."
        );
      }
    } catch (error) {
      console.error(error);

      setError(
        error?.message ||
          "We could not find a Rolo account associated with these details."
      );
    } finally {
      setLoading(false);
    }
  };

  // =========================================================
  // STEP 2 - REASON
  // =========================================================

  const handleReasonContinue = () => {
    setError("");

    if (!selectedReason) {
      setError("Please select a reason for deleting your account.");
      return;
    }

    // Validate custom reason
    if (selectedReason === "Other reasons" && !otherReason.trim()) {
      setError("Please tell us your reason for deleting your account.");
      return;
    }

    setShowConfirmation(true);
  };

  // =========================================================
  // STEP 3 - SEND OTP
  // =========================================================

  const handleConfirmDeletion = async () => {
    setShowConfirmation(false);
    setError("");
    setLoading(true);

    try {
      // Use custom reason when "Other reasons" is selected
      const finalReason =
        selectedReason === "Other reasons"
          ? otherReason.trim()
          : selectedReason;

      const response = await sendDeleteAccountOtp({
        mobile_no: mobileNumber,
        delete_reason: finalReason,
      });

      console.log("Send OTP:", response);

      if (response?.success === "1") {
        setStep(4);
      } else {
        setError(
          response?.message ||
            "Unable to send OTP. Please try again."
        );
      }
    } catch (error) {
      console.error(error);

      setError(
        error?.message ||
          "Unable to send OTP. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  // =========================================================
  // STEP 4 - VERIFY OTP + DELETE
  // =========================================================

  const handleDeleteAccount = async (e) => {
    e.preventDefault();

    setError("");

    if (otp.length !== 6) {
      setError("Please enter the 6-digit OTP.");
      return;
    }

    setLoading(true);

    try {
      // Use custom reason when "Other reasons" is selected
      const finalReason =
        selectedReason === "Other reasons"
          ? otherReason.trim()
          : selectedReason;

      const response = await deleteRoloAccount({
        mobile_no: mobileNumber,
        delete_reason: finalReason,
        otp,
      });

      console.log("Delete Account:", response);

      if (response?.success === "1") {
        setStep(5);
      } else {
        setError(
          response?.message ||
            "Unable to delete your account. Please check the OTP."
        );
      }
    } catch (error) {
      console.error(error);

      setError(
        error?.message ||
          "Unable to delete your account. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  // =========================================================
  // BACK
  // =========================================================

  const handleBack = () => {
    setError("");

    if (step === 2) {
      setStep(1);
    }

    if (step === 4) {
      setStep(2);
      setOtp("");
    }
  };

  // =========================================================
  // RENDER
  // =========================================================

  return (
    <div className="delete-page">

      {/* HEADER */}

      <header className="delete-header">
        <div className="delete-header-inner">
         <img src={logo} alt="Rolo Logo" className="delete-logo" />
        </div>
      </header>

      <main className="delete-main">

        {/* PAGE TITLE */}

        <div className="delete-title">
          <h1>Delete Account</h1>

          <p>
            We're sorry to see you go. Follow the steps below
            to permanently delete your Rolo account.
          </p>
        </div>

        {/* PROGRESS */}

        {step < 5 && (
          <div className="delete-progress">

            {[1, 2, 3, 4].map((item) => (
              <React.Fragment key={item}>

                <div
                  className={`progress-step ${
                    step >= item ? "active" : ""
                  }`}
                >
                  <span>{item}</span>
                </div>

                {item !== 4 && (
                  <div
                    className={`progress-line ${
                      step > item ? "active" : ""
                    }`}
                  />
                )}

              </React.Fragment>
            ))}

          </div>
        )}

        {/* ERROR */}

        {error && (
          <div className="delete-error">
            {error}
          </div>
        )}

        {/* ===================================================
            STEP 1
        =================================================== */}

        {step === 1 && (
          <section className="delete-section">

            {!hasActiveShield ? (
              <>
                <h2>Verify your account</h2>

                <p className="section-description">
                  Enter the mobile number registered with your
                  Rolo account.
                </p>

                <form onSubmit={handleCheckAccount}>

                  <label>Mobile Number</label>

                  <div className="mobile-input">

                    <span>+91</span>

                    <input
                      type="tel"
                      inputMode="numeric"
                      maxLength={10}
                      value={mobileNumber}
                      placeholder="Enter mobile number"
                      onChange={(e) => {
                        setMobileNumber(
                          e.target.value
                            .replace(/\D/g, "")
                            .slice(0, 10)
                        );

                        setError("");
                      }}
                    />

                  </div>

                  <button
                    type="submit"
                    className="rolo-button"
                    disabled={loading}
                  >
                    {loading
                      ? "Checking..."
                      : "Continue"}
                  </button>

                </form>
              </>
            ) : (
              <div className="shield-message">

                <h2>RoloShield Linked to Your Account</h2>

                <p>
                  You currently have an active RoloShield
                  linked to this account.
                </p>

                <p>
                  Please dispose of or transfer your RoloShield
                  before deleting your Rolo account.
                </p>

                <button
                  className="secondary-button"
                  onClick={() => {
                    setHasActiveShield(false);
                    setMobileNumber("");
                  }}
                >
                  Use another number
                </button>

              </div>
            )}

          </section>
        )}

        {/* ===================================================
            STEP 2
        =================================================== */}

        {step === 2 && (
          <section className="delete-section">

            <h2>
              Why do you want to delete your Rolo account?
            </h2>

            <p className="section-description">
              Please select the reason that best describes
              your decision.
            </p>

            <div className="reason-list">

              {DELETE_REASONS.map((reason) => (
                <label
                  key={reason}
                  className={`reason-item ${
                    selectedReason === reason
                      ? "selected"
                      : ""
                  }`}
                >

                  <input
                    type="radio"
                    name="deleteReason"
                    value={reason}
                    checked={selectedReason === reason}
                    onChange={(e) => {
                      const value = e.target.value;

                      setSelectedReason(value);
                      setError("");

                      // Clear custom reason when another option is selected
                      if (value !== "Other reasons") {
                        setOtherReason("");
                      }
                    }}
                  />

                  <span className="radio-circle" />

                  <span>{reason}</span>

                </label>
              ))}

            </div>

            {/* OTHER REASON TEXT BOX */}

            {selectedReason === "Other reasons" && (
              <div className="other-reason-box">

                <label htmlFor="otherReason">
                  Please tell us why you want to delete your
                  account
                </label>

                <textarea
                  id="otherReason"
                  value={otherReason}
                  placeholder="Enter your reason..."
                  maxLength={100}
                  rows={2}
                  onChange={(e) => {
                    setOtherReason(e.target.value);
                    setError("");
                  }}
                />

                <div className="character-count">
                  {otherReason.length}/100
                </div>

              </div>
            )}

            <div className="action-row">

              <button
                type="button"
                className="secondary-button"
                onClick={handleBack}
              >
                Back
              </button>

              <button
                type="button"
                className="rolo-button"
                onClick={handleReasonContinue}
              >
                Continue
              </button>

            </div>

          </section>
        )}

        {/* ===================================================
            STEP 4
        =================================================== */}

        {step === 4 && (
          <section className="delete-section otp-section">

            <h2>Verify Your Account</h2>

            <p className="section-description">
              We have sent an OTP to your registered mobile
              number.
            </p>

            <form onSubmit={handleDeleteAccount}>

              <label>Enter OTP</label>

              <input
                className="otp-input"
                type="tel"
                inputMode="numeric"
                maxLength={6}
                value={otp}
                placeholder="000000"
                onChange={(e) => {
                  setOtp(
                    e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 6)
                  );

                  setError("");
                }}
              />

              <button
                type="submit"
                className="delete-confirm-button"
                disabled={loading}
              >
                {loading
                  ? "Deleting..."
                  : "Verify & Delete Account"}
              </button>

            </form>

            <button
              type="button"
              className="back-link"
              onClick={handleBack}
            >
              Back to reason
            </button>

          </section>
        )}

        {/* ===================================================
            STEP 5
        =================================================== */}

        {step === 5 && (
          <section className="delete-section success-section">

            <div className="success-check">
              ✓
            </div>

            <h2>Account Deleted</h2>

            <p>
              Your Rolo account has been successfully deleted.
            </p>

            <p className="small-text">
              Thank you for using Rolo.
            </p>

            <a
              href="/"
              className="rolo-button success-button"
            >
              Go to Rolo
            </a>

          </section>
        )}

      </main>

      {/* =====================================================
          CONFIRMATION MODAL
      ===================================================== */}

      {showConfirmation && (
        <div className="modal-overlay">

          <div className="delete-modal">

            <h2>
              Are you sure you want to delete your Rolo account?
            </h2>

            <p>
              Account deletion will permanently remove your
              Rolo account and associated data, subject to data
              that Rolo may be required to retain for legal,
              security, or regulatory purposes.
            </p>

            <div className="modal-actions">

              <button
                type="button"
                className="secondary-button"
                onClick={() => {
                  setShowConfirmation(false);
                }}
              >
                Cancel
              </button>

              <button
                type="button"
                className="delete-confirm-button modal-delete"
                onClick={handleConfirmDeletion}
                disabled={loading}
              >
                {loading
                  ? "Processing..."
                  : "Confirm"}
              </button>

            </div>

          </div>

        </div>
      )}

    </div>
  );
}

export default DeleteAccount;

